import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import {
	Button,
	Col,
	Form,
	FormFeedback,
	FormGroup,
	Input,
	Label,
	Row,
} from "reactstrap";
import setorService from "../../../../services/SetorService";
import * as Yup from "yup";
import { useFormik } from "formik";
import withRouter from "../../../../components/Common/withRouter";
import { useNavigate } from "react-router-dom";
import { FloppyDisk } from "@phosphor-icons/react";

const FormSetor = (props) => {
	const [data, setData] = useState(null);

	document.title = "Senda | Setor";

	const params = props.router.params;
	const id = params?.id;

	const navigate = useNavigate();

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			name: data?.name || "",
		},
		validationSchema: Yup.object({
			name: Yup.string().required("Por favor, informe o nome do setor!"),
		}),
		onSubmit: async (values) => {
			if (id) {
				await setorService.put(id, values);
			} else {
				await setorService.post(values);
			}
			navigate("/lista-setores");
		},
	});

	const getItems = async () => {
		try {
			const response = await setorService.getById(id);
			setData(response);
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		if (id) {
			getItems();
		}
	}, []);

	return (
		<div className="page-content">
			<Breadcrumbs
				title="Setores"
				breadcrumbItem="Cadastro de setor"
				backLink="/lista-setores"
			/>

			<div
				className="container-fluid"
				style={{
					backgroundColor: "white",
					padding: 20,
					borderRadius: 10,
					marginTop: 25,
				}}
			>
				<Form
					className="needs-validation"
					onSubmit={(e) => {
						e.preventDefault();
						validation.handleSubmit();
						return false;
					}}
				>
					<Row>
						<Col md="12">
							<FormGroup className="mb-3">
								<Label htmlFor="validationCustom01">
									Nome do setor
								</Label>
								<Input
									name="name"
									placeholder="First name"
									type="text"
									className="form-control"
									id="validationCustom01"
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.name || ""}
									invalid={
										validation.touched.name &&
										validation.errors.name
											? true
											: false
									}
								/>
								{validation.touched.name &&
								validation.errors.name ? (
									<FormFeedback type="invalid">
										{validation.errors.name}
									</FormFeedback>
								) : null}
							</FormGroup>
						</Col>
					</Row>
					<div
						className="page-title-right"
						style={{ display: "flex", justifyContent: "end" }}
					>
						<Button
							type="submit"
							style={{
								background: "none",
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
								width: 150,
							}}
						>
							<FloppyDisk size={16} /> Salvar
						</Button>
					</div>
				</Form>
			</div>
		</div>
	);
};
FormSetor.propTypes = {
	preGlobalFilteredRows: PropTypes.any,
};

export default withRouter(FormSetor);
